module.exports = __webpack_public_path__ + "static/Tulip-10d552f5530d305f39bc34c833efa515.svg";